import { useParams } from 'react-router-dom';

import { useFetchCompanyContacts } from './useFetchCompanyContacts';

export const useFetchCompanyContactsFromURL = () => {
  const companyId = useParams<{ companyId: string }>().companyId;
  return useFetchCompanyContacts(companyId);
};
